import PropTypes from 'prop-types'
import React from 'react'

const Image = (props) => {
    const {
        src,
        alt = '',
        className = '',
        onClick,
        width,
        height,
        style = {},
        isStatic = true,
        loading = 'lazy',
        fallbackSrc = '/images/default_product.svg',
        ...otherProps
    } = props

    const imageSrc = isStatic ? `${process.env.PUBLIC_URL}${src}` : src

    return (
        <img
            src={imageSrc}
            alt={alt}
            className={className}
            onClick={onClick}
            style={style}
            width={width}
            height={height}
            loading={loading}
            onError={(e) => {
                e.target.onerror = null
                e.target.src = `${process.env.PUBLIC_URL}${fallbackSrc}`
                e.target.width = width
                e.target.height = height
            }}
            {...otherProps}
        />
    )
}

Image.propTypes = {
    fallbackSrc: PropTypes.string,
    isStatic: PropTypes.bool,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    loading: PropTypes.oneOf(['lazy', 'eager']),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default Image
